import { PAYMENT_BASE_URL } from "../../../constants";

export const TRANSFERS_BASE_URL = `${PAYMENT_BASE_URL}v2/transactions`;
